import React from 'react';

import IntegrationView from '../../../../SiteAdminView/IntegrationView';

const IntegrationsTab = () => <IntegrationView siteView={false} />;

export default IntegrationsTab;
